import { useEffect, useState } from "react";
import Table from "./Table";
import AddHotel from "./AddAmenity";
import "./style.css";
import MessageProvider from "./Context";
import REACT_APP from "../../../environment";
import axios from "axios";

const Hotel = () => {
    const [isWaiting, setIsWaiting] = useState(false);
    const [amenityGroups, setAmenityGroups] = useState([]);

    const getAmenityGroups = async () => {
        await axios
            .get(`${REACT_APP.URL}/api/hdp/tts/adm/hotel/amenity/group`, {
                headers: { Authorization: sessionStorage.getItem("token"), "client-id": REACT_APP.CLIENTID, "client-secret": REACT_APP.SECRET },
            })
            .then((res) => setAmenityGroups(res.data.data))
            .catch((err) => console.log(err));
    };

    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);

    const getAmenities = async () => {
        await axios
            .get(`${REACT_APP.URL}/api/hdp/tts/adm/hotel/amenity`, {
                headers: { Authorization: sessionStorage.getItem("token"), "client-id": REACT_APP.CLIENTID, "client-secret": REACT_APP.SECRET },
            })
            .then((res) => {
                setData(res.data.data);
                setLoading(false);
                setError(false);
            })
            .catch((err) => {
                console.log(err);
                setError(true);
                setLoading(false);
            });
    };



    useEffect(() => {
        getAmenityGroups();
    }, []);

    return (
        <div className="hotel">
            {isWaiting && <div className="ca-overlay"></div>}
            <MessageProvider>
                <Table setIsWaiting={setIsWaiting} amenityGroups={amenityGroups} getAmenities={getAmenities} error={error} loading={loading} data={data} />
                <AddHotel amenityGroups={amenityGroups} getAmenities={getAmenities} />
            </MessageProvider>
        </div>
    );
};

export default Hotel;
